import { render, staticRenderFns } from "./RecipientFieldDb.vue?vue&type=template&id=038168c3&scoped=true"
import script from "./RecipientFieldDb.ts?vue&type=script&lang=ts&external"
export * from "./RecipientFieldDb.ts?vue&type=script&lang=ts&external"
import style0 from "./RecipientFieldDb.vue?vue&type=style&index=0&id=038168c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038168c3",
  null
  
)

export default component.exports